import React from 'react';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';


const FilterPanel = ({ 
  dateRange, 
  setDateRange, 
  selectedCompany, 
  setSelectedCompany,
  onExport,
  onRefresh 
}) => {
  const dateRangeOptions = [
    { value: 'today', label: 'Today' },
    { value: 'week', label: 'Last 7 Days' },
    { value: 'month', label: 'Last 30 Days' },
    { value: 'quarter', label: 'Last Quarter' },
    { value: 'year', label: 'Last Year' },
    { value: 'custom', label: 'Custom Range' }
  ];

  const companyOptions = [
    { value: 'all', label: 'All Companies' },
    { value: 'eppme', label: 'Eppme Digital Technologies Ltd' },
    { value: 'zetavista', label: 'Zetavista Analytics' },
    { value: 'degrey', label: 'DeGrey Digital Technologies Ltd' }
  ];

  return (
    <div className="bg-card rounded-lg p-6 shadow-brand">
      <div className="flex flex-col lg:flex-row gap-4 items-start lg:items-end">
        <div className="flex-1 w-full lg:w-auto">
          <Select
            label="Date Range"
            options={dateRangeOptions}
            value={dateRange}
            onChange={setDateRange}
          />
        </div>
        <div className="flex-1 w-full lg:w-auto">
          <Select
            label="Company"
            options={companyOptions}
            value={selectedCompany}
            onChange={setSelectedCompany}
          />
        </div>
        <div className="flex gap-2 w-full lg:w-auto">
          <Button 
            variant="outline" 
            iconName="RefreshCw" 
            iconPosition="left"
            onClick={onRefresh}
          >
            Refresh
          </Button>
          <Button 
            variant="default" 
            iconName="Download" 
            iconPosition="left"
            onClick={onExport}
          >
            Export
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;